import DashboardIntlProvider from './DashboardIntlProvider'

export default DashboardIntlProvider
